import { observable, action, makeObservable, set } from 'mobx';
import { v4 as generateRandomId } from 'uuid';

import { ChipsBooleanType, ChipsDateType, ChipsStringType, PartnerType } from '../../shared/support/modelTypes';

export interface PartnersListStoreType {
	itemsPerPage: number;
	currentPage: number;
	list: Array<any>;
	responseCode: number;
	filterOrder: Array<string>;
	filterSkip: number;
	filterWhere: { deleted?: boolean };
	pluralName: string;
	collectedModels: Array<any>;
	sortConfig: { collId: string; isAsc: boolean };
	chips: Array<any>;
	chipsFields: { name: ChipsStringType; sequenceNumber: ChipsStringType; createdAtGt: ChipsDateType; createdAtLt: ChipsDateType; deleted: ChipsBooleanType };
	isFirstLoad: boolean;
	name: string;
	filterGroupOrder: Array<string>;
	filterGroupWhere: { deleted?: boolean; elementType?: number };
	idArray: Array<any>;
	group: any;
	isSelected: boolean;
	treeState: any;
	groupsTree: Array<any>;
	groups: Array<any>;
	rootId: string;
	bulkEditingFields: {
		parentId: string | null;
		parent?: PartnerType;
	};
	searchFields: { deleted: boolean };
	showChildGroupsElements: boolean;
	setValue(model: any, key: string, value: any): void;
}

class PartnersListStore implements PartnersListStoreType {
	constructor() {
		makeObservable(this, {
			itemsPerPage: observable,
			currentPage: observable,
			list: observable,
			responseCode: observable,
			filterOrder: observable,
			filterSkip: observable,
			filterWhere: observable,
			pluralName: observable,
			collectedModels: observable,
			sortConfig: observable,
			chips: observable,
			chipsFields: observable,
			isFirstLoad: observable,
			name: observable,
			filterGroupOrder: observable,
			filterGroupWhere: observable,
			idArray: observable,
			group: observable,
			isSelected: observable,
			treeState: observable,
			groupsTree: observable,
			groups: observable,
			rootId: observable,
			bulkEditingFields: observable,
			searchFields: observable,
			showChildGroupsElements: observable,
			setValue: action
		});
	}
	name = 'OrmPartner';
	itemsPerPage = 50;
	currentPage = 0;
	list = [] as Array<any>;
	responseCode = 0;
	filterOrder = ['createdAt DESC'];
	filterSkip = 0;
	filterWhere = { deleted: false, elementType: 0 };
	pluralName = 'partners';
	collectedModels = [] as Array<any>;
	sortConfig = { collId: '', isAsc: false };
	chips = [];
	isFirstLoad = true;
	showChildGroupsElements = false;
	chipsFields = {
		name: {
			id: null,
			chips: [],
			title: 'Наименование',
			isLocalizedString: true
		},
		sequenceNumber: {
			id: null,
			chips: [],
			title: 'Номер'
		},
		createdAtGt: {
			isDate: true,
			id: null,
			chips: [],
			isGt: true
		},
		createdAtLt: {
			isDate: true,
			id: null,
			chips: [],
			isGt: false
		},
		deleted: {
			id: false,
			display: { isChecked: false, title: 'Отображать' },
			doNotDisplay: { isChecked: true, title: 'Не отображать' },
			chips: [
				{
					id: generateRandomId(),
					name: {
						ru: 'Удаленные: не отображать'
					}
				}
			],
			isBoolean: true,
			title: 'Удаленные'
		}
	};
	groups = [] as Array<any>;
	groupsTree = [] as Array<any>;
	treeState = {
		activeKey: '',
		focusKey: '',
		openNodes: [] as string[],
		nodes: [] as any[]
	};
	isSelected = false;
	group = null;
	idArray = [] as Array<string>;
	filterGroupOrder = ['createdAt DESC'];
	filterGroupWhere = { deleted: false, elementType: 1 };
	bulkEditingFields = {
		parentId: null
	};
	rootId = generateRandomId();
	searchFields = {
		deleted: false
	};
	setValue(model: any, key: string, value: any) {
		set(model, key, value);
	}
}

export const partnersListStore = new PartnersListStore();

export default PartnersListStore;
